// 2020-06-27export { TropaMovimientoPopupComponent } from './tropa-movimiento-popup.component';